import { useContext } from "react";
import { RegisterContext } from "./RegisterContextProvider";

const useRegisterContext = () => useContext(RegisterContext);

export default useRegisterContext;
